import moment from "moment";
import {
  ApprovalDetailInformationEntity,
  ApprovalEntity,
  ApprovalTemplateEntity,
  UserEntity
} from "../../../../generated/graphql";
import { Content, Label, Subscription } from "../styles";

interface BasicInfoDisplayProps {
  departmentName?: string;
  user?: UserEntity;
  isRequest?: boolean;
  data?: ApprovalEntity;
  template?: ApprovalTemplateEntity;
  approvalDetailInformation?: ApprovalDetailInformationEntity;
}

const BasicInfoDisplay = ({
  departmentName,
  user,
  isRequest,
  data,
  template,
  approvalDetailInformation
}: BasicInfoDisplayProps) => {
  return (
    <>
      <Content>
        <Label isSpacing>{`소   속`}</Label>
        <Subscription>{departmentName}</Subscription>
      </Content>
      <Content>
        <Label isSpacing>{`이   름`}</Label>
        <Subscription>
          {isRequest
            ? user?.name ?? ""
            : approvalDetailInformation?.employeeName ?? ""}
        </Subscription>
      </Content>
      <Content>
        <Label isSpacing>{`직   급`}</Label>
        <Subscription>
          {isRequest
            ? user?.userPosition ?? ""
            : approvalDetailInformation?.userPosition ?? ""}
        </Subscription>
      </Content>
      <Content>
        <Label>문서번호</Label>
        <Subscription>{data?.docNumber}</Subscription>
      </Content>
      <Content>
        <Label>{`작 성 일`}</Label>
        <Subscription>
          {approvalDetailInformation?.signUpDateTimeTemp ||
            moment().format("YYYY-MM-DD")}
        </Subscription>
      </Content>
      <Content>
        <Label>정보구분</Label>
        <Subscription>
          {template?.name ?? approvalDetailInformation?.categoryName}
        </Subscription>
      </Content>
    </>
  );
};

export default BasicInfoDisplay;
